import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Text } from '@chakra-ui/react';
import { Section } from '@whitbread-eos/atoms';
import { getPIBrandText, renderSanitizedHtml, useSemanticTypography, useStaticHotelInformation } from '@whitbread-eos/utils';
import { useTranslation } from 'next-i18next';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function HotelParkingInformation() {
  var _useStaticHotelInform = useStaticHotelInformation(),
    parkingDescription = _useStaticHotelInform.parkingDescription,
    isLoading = _useStaticHotelInform.isLoading,
    isError = _useStaticHotelInform.isError,
    error = _useStaticHotelInform.error,
    brand = _useStaticHotelInform.brand,
    title = _useStaticHotelInform.title;
  var _useTranslation = useTranslation(['common']),
    t = _useTranslation.t;
  var getTypographyProps = useSemanticTypography();
  if (isLoading) {
    return _jsx(Text, {
      children: t('searchresults.list.hotel.loading')
    });
  }
  if (isError) {
    return _jsx(Text, {
      children: error.message
    });
  }
  if (!parkingDescription) {
    return null;
  }
  return _jsx(Section, {
    dataTestId: "hdp_parking",
    children: _jsxs(Box, _objectSpread(_objectSpread({
      maxW: "full",
      "data-testid": "hotel-details-parking"
    }, containerStyles), {}, {
      children: [_jsxs(Text, _objectSpread(_objectSpread({
        as: "h3"
      }, getTypographyProps(headingParkingLegacyTypography, headingParkingSemanticTypography)), {}, {
        children: [t('hoteldetails.mapparking.title'), getPIBrandText(t, brand), title]
      })), _jsx(Box, _objectSpread(_objectSpread({
        mt: "1",
        className: "formatLinks"
      }, getTypographyProps({}, formatLinksParkingSemanticTypography)), {}, {
        children: renderSanitizedHtml(parkingDescription)
      }))]
    }))
  });
}
var formatLinksParkingSemanticTypography = {
  textStyle: 'body-m-regular'
};
var headingParkingLegacyTypography = {
  fontWeight: 'semibold',
  fontSize: '2xl',
  lineHeight: '4'
};
var headingParkingSemanticTypography = {
  textStyle: {
    base: 'heading-s',
    md: 'heading-m'
  }
};
var containerStyles = {
  my: {
    base: '1.5rem',
    md: '3rem'
  }
};